import { Button as BootstrapButton } from 'react-bootstrap'
import styled, { ThemeProvider, keyframes } from 'styled-components/macro'
import { CgSpinner } from 'react-icons/cg'
import theme from '../../theme'

const PrimaryTheme = {
  background: '#154ba0',
  border: '#154ba0',
  color: '#fff',
  hover: {
    background: '#154ba0',
    border: '#154ba0',
    color: '#fff',
  },
}

const SecondaryTheme = {
  background: '#fff',
  border: '#154ba0',
  color: '#154ba0',
  hover: {
    background: '#fff',
    border: '#154ba0',
    color: '#154ba0',
  },
}

const YellowTheme = {
  background: '#fcbc2e',
  border: '#fcbc2e',
  color: '#1f1528',
  hover: {
    background: '#ffcc5d',
    border: '#ffcc5d',
    color: '#1f1528',
  },
}

const StyledButton = styled(BootstrapButton)`
  background-color: #154ba0;
  padding: 0.75rem 1rem;
  display: inline-block;
  text-align: center;
  text-transform: uppercase;
  line-height: 1rem;
  border-radius: 0.5rem;
  font-size: 13px;
  font-weight: 600;
  color: #fff;

  &:hover,
  &:focus,
  &:active {
    background-color: #154ba0;
    color: #fff;
  }

  &:disabled {
    background-color: #727eaa;
    color: rgba(255, 255, 255, 0.5);
    border: none;
  }

  svg {
    margin-right: 0.5rem;
  }
`
const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`
const LoadingIcon = styled(CgSpinner)`
  animation: ${spin} 0.75s linear infinite;
`

interface IButtonProps {
  color?: 'primary' | 'secondary' | 'yellow'
  icon?: JSX.Element
  children?: string | JSX.Element | JSX.Element[]
  disabled?: boolean
  loading?: boolean
  loadingText?: string
  onClick?: (e?: any) => void
}

function Button(props: IButtonProps): JSX.Element {
  const { color, icon, children, disabled, loading, loadingText, onClick } = props

  let _theme = PrimaryTheme

  switch (color) {
    case 'primary':
      _theme = PrimaryTheme
      break
    case 'secondary':
      _theme = SecondaryTheme
      break
    case 'yellow':
      _theme = YellowTheme
      break
  }

  return (
    <ThemeProvider theme={_theme}>
      <StyledButton disabled={disabled} onClick={onClick}>
        {loading && <LoadingIcon size={18} />}
        {!loading && icon}
        {loading && loadingText ? loadingText : <>{children}</>}
      </StyledButton>
    </ThemeProvider>
  )
}

Button.defaultProps = {
  color: 'primary',
}

export default Button
